import { useCallback, useEffect, useState } from 'react';
import { Track } from '../../types/Track';
import { buildCrateIndex, cratesForTrack, CrateIndex } from './duplicateCrates';
import { fetchCrateIndex } from './duplicateIpc';

export type DuplicateCrateIndex = ReturnType<typeof useDuplicateCrateIndex>;

/** Loads Serato crate membership once and shares it across every verdict. */
export const useDuplicateCrateIndex = () => {
  const [index, setIndex] = useState<CrateIndex | null>(null);
  const [loading, setLoading] = useState(true);
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    let cancelled = false;

    fetchCrateIndex()
      .then((crates) => {
        if (cancelled) return;
        if (crates.length > 0) {
          setIndex(buildCrateIndex(crates));
          setAvailable(true);
        }
        setLoading(false);
      })
      .catch(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const lookup = useCallback(
    (track: Track) => cratesForTrack(index, track),
    [index],
  );

  return { loading, available, lookup };
};
